import React from "react";
import visualState from "../../../visualState";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import SVGLayout1 from "../../Misc/SvgIcons/SVGLayout1";
import LibraryItem from "./LibraryItem";
import LibraryTree from "./LibraryTree";

let searchTimeout = null;

export default class Library extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    this.vState = new visualState("LibrarySection");

    this.state = {
      pending: false,
      structureSelected: [],
      structureExpanded: [],
      items: {},
      activeItemId: this.props.itemId,

      textSearch: [],
      textSearchPending: false,
      textSearchValue: "",

      structureVisible: this.vState.read("structureVisible", true),
      structureFlat: false,
    };
  }
  componentDidMount() {
    this.load();
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.essence !== this.props.essence) {
      this.load();
    }
    if (prevProps.itemId !== this.props.itemId) {
      this.setState({ activeItemId: this.props.itemId });
    }
    this.renderButtons();
  }

  load = async () => {
    this.setState({ pending: true });
    let items = false;

    let fetchFn = this.state.textSearchValue
      ? this.context.api.qo
      : this.context.api.qoo;

    items = await fetchFn(
      `/${this.props.essence}/list`,
      { search: this.state.textSearch || [] },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState(
      {
        pending: false,
        items,
        structureFlat: this.state.textSearchValue ? true : false,
      },
      () => this.treeRestoreExpanded(this.props.itemId)
    );
  };

  treeRestoreExpanded = (id) => {
    if (!id) {
      this.setState({ structureExpanded: [], structureSelected: [] });
    } else {
      const expanded = this.treeGetPath(id);
      this.setState({ structureExpanded: expanded, structureSelected: id });
    }
  };
  treeGetPath = (id) => {
    let result = [];
    const items = this.state.items;
    if (id && Object.keys(items).length > 0) {
      if (items[`_${id}`]) {
        let parentNodeId = items[`_${id}`].node;
        result = [String(id)];
        while (parentNodeId) {
          result.push(String(parentNodeId));
          parentNodeId = items[`_${parentNodeId}`].node;
        }
      }
    }
    return result.reverse();
  };
  treeHandleToggle = (event, nodeIds) => {
    this.setState({ structureExpanded: nodeIds });
  };
  treeHandleSelect = (event, nodeIds) => {
    this.setState({ structureSelected: nodeIds });
  };

  toggleVisibleStructure = () => {
    this.setState((state) => {
      this.vState.save({ structureVisible: !state.structureVisible });
      return { structureVisible: !state.structureVisible };
    });
  };

  onTextSearchCancell = () => {
    window.clearTimeout(searchTimeout);
    this.setState(
      {
        textSearchValue: "",
        textSearchPending: false,
        textSearch: [],
      },
      async (state) => {
        await this.load();
      }
    );
  };

  onTextSearch = (searchValue) => {
    this.setState({ textSearchValue: searchValue });
    this.setState({ textSearchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      if (searchValue) {
        let textSearch = searchValue
          ? [
              {
                lstr: "(",
                field: "name",
                compare: "IKE",
                value: `%${searchValue}%`,
              },
              {
                condition: "OR",
                field: "description",
                compare: "IKE",
                value: `%${searchValue}%`,
                rstr: ")",
              },
            ]
          : [];
        this.setState({ textSearchPending: false, textSearch }, () =>
          this.load()
        );
      } else {
        this.onTextSearchCancell();
      }
    }, 1000);
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Отображение дерева"
          onClick={this.toggleVisibleStructure}
          className={`btn btn-icon ${
            this.state.structureVisible
              ? "bg-light-primary bg-hover-light"
              : "bg-light bg-hover-light-primary"
          }    mr-2`}
        >
          <span
            className={`svg-icon ${
              this.state.structureVisible
                ? "svg-icon-primary"
                : "svg-icon-light"
            } `}
          >
            <SVGLayout1 />
          </span>
        </button>
      </>
    );
  };

  render() {
    return (
      <>
        <CrumbsProvider
          title={this.props.title}
          link={`/${this.props.essence}/`}
        />
        <div className="container h-100">
          <div className="row  h-100">
            {this.state.structureVisible ? (
              <div className="col-lg-4 m-lg-0 mb-3">
                <div className="card card-custom card-stretch">
                  <div className="card-body px-5 py-5">
                    <Blocker on={this.state.pending}>
                      <div className="text-nowrap d-flex mb-4">
                        {this.state.textSearchPending ? (
                          <div className="spinner mr-10"></div>
                        ) : (
                          ""
                        )}
                        <div className="w-100">
                          <div className="input-group">
                            <input
                              className="form-control form-control-solid d-inline-block w-auto"
                              type="text"
                              placeholder="Поиск"
                              value={this.state.textSearchValue}
                              onChange={(e) =>
                                this.onTextSearch(e.target.value)
                              }
                            />
                            {this.state.textSearchValue ? (
                              <div className="input-group-append">
                                <button
                                  title="Отменить поиск"
                                  className="btn btn-icon btn-secondary"
                                  type="button"
                                  onClick={() => this.onTextSearchCancell()}
                                >
                                  <i className="fa text-muted fa-close"></i>
                                </button>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <LibraryTree
                        expanded={this.state.structureExpanded}
                        selected={this.state.structureSelected}
                        onNodeToggle={this.treeHandleToggle}
                        onNodeSelect={this.treeHandleSelect}
                        items={this.state.items}
                        essence={this.props.essence}
                        flat={this.state.structureFlat}
                      />
                    </Blocker>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="col-lg">
              <Blocker on={this.state.pending}>
                <LibraryItem
                  id={this.state.activeItemId}
                  essence={this.props.essence}
                  treeItems={this.state.items}
                />
              </Blocker>
            </div>
          </div>
        </div>
      </>
    );
  }
}
